import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { GenericReportPage } from "./generic-report.page";
import { SurveyModule } from "src/app/organisms/survey/survey.module";
import { TranslateModule } from "@ngx-translate/core";
import { IsValidReportModule } from "src/app/pipes/is-valid-report/is-valid-report.module";
import { ReportsWithQuestionModule } from "src/app/pipes/reports-with-question/reports-with-question.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SurveyModule,
    TranslateModule,
    IsValidReportModule,
    SurveyModule,
    ReportsWithQuestionModule,
  ],
  declarations: [GenericReportPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GenericReportPageModule {}
